import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withImage from '../../../../shared/components/utils/hoc/withImage';

const SearchImage = styled.img<React.CSSProperties>`
  position: absolute;
  right: ${-30 * Screen.widthRatio}px;
  top: ${-25 * Screen.widthRatio}px;
  width: ${628 * Screen.widthRatio}px;
  height: ${366 * Screen.widthRatio}px;
  object-fit: cover;
`;

export default withImage(SearchImage);
